import { SideReference } from './SideReference';
import { reverseSide } from './Side';
import { TileView } from './TileView';
let nextId = 0;
export class Tile {
    constructor() {
        this.links = [null, null, null, null];
        this.id = nextId++;
        this.entities = new Set();
        this.walkable = true;
        this.tileViews = Array(8);
        this.propertyDominance = Math.random();
        for (let i = 0; i < 8; i++) {
            this.tileViews[i] = new TileView(this, i);
        }
    }
    getReference(i) {
        return this.links[i];
    }
    unlink(i, reciprocate = true) {
        if (this.links[i]) {
            const link = this.links[i];
            if (reciprocate) {
                link.to.unlink(link.destSide, false);
            }
            this.links[i] = null;
        }
    }
    link(fromSide, toTile, toSide = reverseSide(fromSide), { reflect = false, addReverse = true } = {}) {
        this.unlink(fromSide);
        this.links[fromSide] = SideReference.fromOpts(toTile, fromSide, toSide, reflect);
        if (addReverse) {
            toTile.link(toSide, this, fromSide, {
                addReverse: false,
                reflect
            });
        }
        this.onLinked(this.links[fromSide]);
    }
    onLinked(side) {
    }
    getView(mtx) {
        return this.tileViews[mtx];
    }
    render(ctx, t, playerDist, playerShear) {
        this.loadTimer = t;
    }
    isolate() {
        for (let i = 0; i < 4; i++) {
            this.unlink(i);
        }
    }
    stepOn(t) {
    }
    interact(t) {
    }
    track(entity) {
        this.entities.add(entity);
    }
}



//////////////////
// WEBPACK FOOTER
// ./src/Tile.ts
// module id = 4
// module chunks = 0